import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { TextVariants } from "../../theme";
import { Box } from "theme-ui";
import { wholeNumber } from "../../utils/number-format";
export const NotificationIndicator = ({ 
/**
 * How many items are in the counter
 */
items = 0, 
/**
 * Whether you want to alarm the user and bring their critical attention to the issue
 */
highlight = false }) => {
    const Wrapper = ({ children }) => {
        return (_jsx(Box, { sx: {
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }, children: children }));
    };
    if (items > 0) {
        return (_jsx(Wrapper, { children: _jsx(Box, { sx: {
                    width: "24px",
                    height: "24px",
                    borderRadius: "24px",
                    bg: highlight ? "red.0" : "blue.0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }, children: _jsx("div", { sx: {
                        variant: `text.${TextVariants.label3}`,
                        fontSize: "scale-4",
                        color: "white.0",
                        textAlign: "center"
                    }, children: wholeNumber(items) }) }) }));
    }
    else {
        return (_jsx(Wrapper, { children: _jsx(Box, { sx: {
                    width: "8px",
                    height: "8px",
                    borderRadius: "8px",
                    bg: "blue.0"
                } }) }));
    }
};
//# sourceMappingURL=NotificationIndicator.js.map